export enum SkillsRoutesConfig {
	BASE_URL = 'skills',
	LIST_SEGMENT = 'list',
	JOB_TITLES_SEGMENT = 'job-titles',
	NEW_SEGMENT = 'new',
	EDIT_SEGMENT = 'edit',
	GUID_SEGMENT = ':guid',
	JOB_TITLE_NAME_SEGMENT = ':job-title',
	COURSES_SEGMENT = 'courses',
	LEARNERS_SEGMENT = 'learners'
}

export class SkillsRoutes {
	public static readonly SKILLS = SkillsRoutesConfig.BASE_URL;
	public static readonly SKILLS_LIST = SkillsRoutesConfig.LIST_SEGMENT;
	public static readonly JOB_TITLES_LIST = SkillsRoutesConfig.JOB_TITLES_SEGMENT;
	public static readonly NEW_SKILL = SkillsRoutesConfig.NEW_SEGMENT;
	public static readonly EDIT_SKILL = `${SkillsRoutesConfig.EDIT_SEGMENT}`;
	public static readonly GUID = `${SkillsRoutesConfig.GUID_SEGMENT}`;
	public static readonly JOB_TITLE_NAME = `${SkillsRoutesConfig.JOB_TITLE_NAME_SEGMENT}`;
	public static readonly COURSES_LIST = `${SkillsRoutesConfig.COURSES_SEGMENT}`;
	public static readonly LEARNERS_LIST = `${SkillsRoutesConfig.LEARNERS_SEGMENT}`;
	public static getSkillDetailsRoute(skillGuid: string): string {
		return `${SkillsRoutes.SKILLS}/${skillGuid}`;
	}
	public static getSkillEditRoute(skillGuid: string): string {
		return `${SkillsRoutes.SKILLS}/${skillGuid}/${SkillsRoutes.EDIT_SKILL}`;
	}
}
